import * as M from "@discovery/prelude/lib/data/maybe";
import { _userProfilesLength } from "@discovery/common-dplus/lib/state";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { HeaderVariants, Tags, Typography } from "../../../atoms/typography";
import { useState, useEffect } from "@discovery/common-dplus/lib/hooks";
import { Button, ButtonVariant } from "../../../../components/atoms/button";
import Strings from "../../../../utils/hardcoded.json";
import { useUser } from "../../../../utils/hooks";
import AllAccess from "../../../molecules/parental-lock/firstFlowModals/allAccess";
import { navigateTo, goBackToPreviousPage } from "../../../../utils/common";
import * as styles from "./styles.css";
import { BackButton } from "../../../../components/atoms/back-button";
import { getUrlParameter } from "../../../../utils/common";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { setAuthRedirectUrl } from "../../../../utils/authUrl";
const ageRestrictedErrorImage = require("./restricted-show.png");
export const RestrictedShowErrorPage = ({ read }) => {
    const { isAnonymous } = useUser();
    const [numberOfUserProfiles] = useGlobalState(_userProfilesLength);
    const [onLanding, setOnLanding] = useState(true);
    const [showParentalLockAccess, setParentalLockAccess] = useState(false);
    const [path, setPath] = useState("landing");
    const onContinue = () => {
        if (isAnonymous) {
            const webAuthRedirectionUrl = read.authService.protocol + "://" + read.authService.domain + "/login";
            const authRedirect = setAuthRedirectUrl(window.location.pathname);
            navigateTo(`${webAuthRedirectionUrl}?returnUrl=${authRedirect}`);
        }
        else {
            const url = window.location.href;
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.set("allAccess", "landing");
            const newParams = searchParams.toString();
            const newurl = url.indexOf("?")
                ? window.location.pathname + `${"?" + newParams}`
                : window.location.pathname + `${"?" + "allAccess=landing"}`;
            onLanding && window.history.pushState({ path: newurl }, "", newurl);
            setParentalLockAccess(true);
            setOnLanding(false);
        }
    };
    useEffect(() => {
        const pathName = getUrlParameter("allAccess");
        if (pathName) {
            setParentalLockAccess(true);
            setPath(pathName);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(React.Fragment, null,
        showParentalLockAccess && (React.createElement(AllAccess, { route: path, read: read, userProfileLength: numberOfUserProfiles, nativeUrl: window.location.href, hideAllAccessPopup: goBackToPreviousPage })),
        React.createElement("div", { className: styles.errorImageWrapper },
            React.createElement(BackButton, { customBackNavigation: true, goBackTo: () => navigateTo(config.standardPageRouteFragments.home) }),
            React.createElement("img", { className: styles.ageRestrictedErrorImg, src: ageRestrictedErrorImage, alt: "ageRestrictedErrorImage" }),
            React.createElement("div", { className: styles.textWrapper },
                React.createElement(Typography, { classNameM: M.of(styles.unableToPlayText), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, Strings.ACTIVATE_ALL_ACCESS_MODE)),
                React.createElement("div", { className: styles.buttonWrapper },
                    React.createElement("div", { id: "#manageAllAccess" },
                        React.createElement(Button, { children: Strings.MANAGE_ALL_ACCESS, variant: ButtonVariant.Primary, onClickM: M.of(() => onContinue()) })))))));
};

